import Avatar from '../common/avatar';
import React from 'react';

const AgentTypingIndicator = () => {
	return (
		<div className={`flex items-end`}>
			<Avatar/>
			<div className="text-gray-500 text-xs mb-1">Agent is typing...</div>
		</div>
	);
};

export default AgentTypingIndicator;
